import { Experiment } from '@naturalcycles/shared'
import { hasCycleChanges } from '@src/app/cnst/quiz/quiz.cnst'
import { QuizPage } from '@src/app/cnst/quiz/quiz-pages.cnst'
import { QuizModifier } from '@src/app/util/quiz.util'
import { QuizSections } from '@src/typings/quiz.enum'
import { AppQuizEngineConfig, AppQuizFlow, QuizSignatureObject } from '@src/typings/quiz.model'
import { eligibleAppleWatchB1InSignupBreakpoint } from './breakpoints/eligible-apple-watch.breakpoint'
import { medicalConditionsB1InSignupBreakpoint } from './breakpoints/medical-conditions.breakpoint'
import { watchToBedB1SignupBreakpoint } from './breakpoints/watch-to-bed.breakpoint'
import { whichWearableB1InSignupBreakpoint } from './breakpoints/which-wearable.breakpoint'

class B1InSignupQuiz implements QuizModifier<AppQuizEngineConfig> {
  public _shouldEnhance(obj: QuizSignatureObject): boolean {
    return ['test'].includes(obj.experiment[Experiment.B1_IN_SIGNUP] || '')
  }

  public enhanceEngineConfig(
    obj: QuizSignatureObject,
    config: AppQuizEngineConfig,
  ): AppQuizEngineConfig {
    if (!this._shouldEnhance(obj)) return config
    // new breakpoints
    config.breakpointActions.medicalConditions = medicalConditionsB1InSignupBreakpoint
    config.breakpointActions.whichWearable = whichWearableB1InSignupBreakpoint
    config.breakpointActions.eligibleAppleWatch = eligibleAppleWatchB1InSignupBreakpoint
    config.breakpointActions.wearWatchToBed = watchToBedB1SignupBreakpoint

    // page guards

    config.guardData = {
      ...config.guardData,
      [QuizPage.eligibleAppleWatchB1InSignup]: state => !!hasCycleChanges(state),
      [QuizPage.wearYourWatchToBedB1InSignup]: state => !!state?.eligibleAppleWatch,
      [QuizPage.whatToTrackWithDevice]: state => !!hasCycleChanges(state),
      [QuizPage.sleepAndLifeStyleInfo]: state =>
        !!state?.wearWatchToBed || !!hasCycleChanges(state),
      [QuizPage.wakeUpTimeConsistency]: state => !!hasCycleChanges(state),
      [QuizPage.snooze]: state => !!state?.wakeUpTimeConsistency,
      [QuizPage.dailyRoutineConsistency]: state => !!state?.snooze,
      [QuizPage.fitResult]: state => !!state?.dailyRoutineConsistency,
    }

    return config
  }

  public enhanceSections(obj: QuizSignatureObject, sections: QuizSections): QuizSections {
    if (!this._shouldEnhance(obj)) return sections

    return sections
  }

  public enhanceInitialFlow(obj: QuizSignatureObject, flow: AppQuizFlow): AppQuizFlow {
    if (!this._shouldEnhance(obj)) return flow
    return flow
  }

  public enhanceEntry(obj: QuizSignatureObject, entry: QuizPage | null): QuizPage | null {
    if (!this._shouldEnhance(obj)) return entry
    return entry
  }

  public enhanceExit(obj: QuizSignatureObject, exit: QuizPage | null): QuizPage | null {
    if (!this._shouldEnhance(obj)) return exit
    return exit
  }
}

export const expB1InSignupQuiz = new B1InSignupQuiz()
